import * as React from 'react';

import * as styles from './PhonesPreloader.css';

export const PhonesPreloader = (): React.JSX.Element => {
  return <div className={styles['loader']}></div>;
};
